import { APIClient } from "../setup/axios/ApiHelper";

const api = new APIClient();

const MapsAPI = {
  getList: (params: any) => api.get('dashboard/list-location-maps', params),
}

export default MapsAPI